module.exports = __webpack_public_path__ + "static/media/segundo.cd313e5b.png";